export const SEARCH_URL = '/courses/search/';
export const UFB_SEARCH_URL = '/organization/search/';
export const PERSONALIZE_URL = '/personalize';
//# sourceMappingURL=constants.js.map